import {
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsBoolean,
  IsString,
} from 'class-validator';

import { UserRoleEnum } from '@app/types';

export class GetCreateEventTypeOptionsDto {
  @IsUUID()
  @IsNotEmpty()
  event_type_id: string;

  @IsUUID()
  @IsOptional()
  parent_event_id?: string;

  @IsBoolean()
  @IsOptional()
  is_batch?: boolean;

  @IsString()
  @IsOptional()
  role?: UserRoleEnum;
}
